<cmps-dialog [class.double]="_formHasNotes === true">
    <cmps-dialog-header [hasExpandAction]="true">
        <div class="header">
            <input
                type="text"
                class="topic"
                [disabled]="true"
                [ngModel]="state?.chat?.topic"
                [ngModelOptions]="{ updateOn: 'blur' }"
                (ngModelChange)="_onTopicChange($event)"
            />
        </div>
    </cmps-dialog-header>
    <cmps-dialog-body class="h-100">
        <div class="d-flex flex-column h-100">
            <div class="px-2">
                <div>
                    <div>
                        {{ _i18n._10058_CREATED_ON_ | translate }}
                        {{
                            state?.chat?.createdOn
                                | cmpsDate: 'EEEE, MMMM d, y, h:mm:ss a'
                        }}
                    </div>
                    <div class="behaviour">
                        <strong class="m-1"
                            >{{
                                _i18n._9422_BEHAVIOUR_ | translate
                            }}&nbsp;</strong
                        >
                        <!--TODO FIXME. see transferCommitmentToTranscript, and commitment component after rootCreateTranscriptResult when behaviours is null or empty-->
                        {{
                            state?.focus?.behaviour?.name ??
                                (_i18n._9986_NO_BEHAVIOUR_SELECTED | translate)
                        }}
                    </div>
                    <div class="sub-behaviour">
                        <strong
                            >{{
                                _i18n._9423_SUB_BEHAVIOUR_ | translate
                            }}&nbsp;</strong
                        >
                        {{
                            state?.focus?.subBehaviour?.name ??
                                (_i18n._9987_NO_SUB_BEHAVIOUR_SELECTED
                                    | translate)
                        }}
                    </div>
                </div>
                <div>
                    <table>
                        <thead>
                            <th class="tbl-header">
                                {{ _i18n._9988_PARTICIPANTS | translate }}
                            </th>
                        </thead>
                        <tr>
                            <td>
                                <button
                                    cmpsButton
                                    (click)="_onFilterParticipantClick(null)"
                                >
                                    <span cmpsButtonLabel>{{
                                        _i18n._10057_ALL_PARTICIPANTS
                                            | translate
                                    }}</span>
                                </button>
                            </td>
                            <td *ngFor="let m of state?.chat?.members">
                                <button
                                    cmpsButton
                                    (click)="_onFilterParticipantClick(m)"
                                >
                                    <span cmpsButtonLabel>{{
                                        m?.msftDisplayName
                                    }}</span>
                                </button>
                            </td>
                        </tr>
                    </table>
                </div>
                <div class="mb-2 row">
                    <form class="d-flex mt-3 mr-1 search-box">
                        <input
                            name="keyWord"
                            class="flex-grow-1 mr-1"
                            [ngModel]="state?.filterOpts?.keyword ?? ''"
                            (ngModelChange)="_onKeywordFilterChange($event)"
                        />
                        <button
                            class="cmps-button--sm"
                            cmpsButton
                        >
                            <span cmpsButtonLabel>{{
                                _i18n._710_SEARCH | translate
                            }}</span>
                        </button>
                    </form>
                    <cmps-date-range
                        class="date-range-time-picker"
                        [dateRange]="state?.filterOpts?.dateRange"
                        [minFromDate]="state?.messages?.at(-1)?.startTime"
                        [maxFromDate]="
                            state?.messages?.[0]?.endTime ??
                            state?.messages?.[0]?.startTime
                        "
                        [minToDate]="state?.messages?.at(-1)?.startTime"
                        [maxToDate]="
                            state?.messages?.[0]?.endTime ??
                            state?.messages?.[0]?.startTime
                        "
                        (dateRangeChange)="_onDateRangeFilterChange($event)"
                    >
                    </cmps-date-range>
                    <form>
                        <div class="reset">
                            <button
                                cmpsIconButton
                                [cmpsTooltipTrigger]="
                                    _i18n._9665_RESET | translate
                                "
                                trigger="hover"
                                (click)="_onResetClick()"
                            >
                                <cmps-icon svgIcon="reload"></cmps-icon>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="px-2 grid-body">
                <div class="row h-100">
                    <div class="col h-100">
                        <div class="h-100 grid-col">
                            <table
                                class="table table-hover table-centered mb-0"
                                [class.grid-tbl]="!_dialogRef?.expanded"
                            >
                                <thead class="table-primary">
                                    <tr>
                                        <th class="grid-tbl-header">
                                            <cmps-checkbox
                                                class="check-all"
                                                [checked]="
                                                    state?.allQuotesAreSelected ??
                                                    false
                                                "
                                                (change)="
                                                    _onSelectAllQuotesClick()
                                                "
                                            >
                                            </cmps-checkbox>
                                        </th>
                                        <th class="grid-tbl-header">
                                            {{
                                                _i18n._9497_DATE___TIME_
                                                    | translate
                                            }}
                                        </th>
                                        <th class="grid-tbl-header">
                                            {{
                                                _i18n._102_USER_NAME | translate
                                            }}
                                        </th>
                                        <th class="grid-tbl-header">
                                            {{
                                                _i18n._9982_CONVERSATION
                                                    | translate
                                            }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container
                                        *ngIf="
                                            !(state?.filteredQuotes?.length > 0)
                                        "
                                    >
                                        <tr>
                                            <td
                                                class="text-center td4"
                                                colspan="4"
                                            >
                                                {{
                                                    _i18n._10051_NO_TRANSCRIPTS_AVAILABLE
                                                        | translate
                                                }}
                                            </td>
                                        </tr>
                                    </ng-container>
                                    <ng-container
                                        *ngIf="state?.chat?.chatId != null"
                                    >
                                        <tr
                                            (click)="
                                                _onQuoteCheckboxChange(line)
                                            "
                                            *ngFor="
                                                let line of state?.filteredQuotes;
                                                let i = index
                                            "
                                        >
                                            <td class="td1">
                                                <cmps-checkbox
                                                    [checked]="
                                                        state
                                                            ?.filteredQuotesSelectedLookup?.[
                                                            i
                                                        ]
                                                    "
                                                    (change)="
                                                        _onQuoteCheckboxChange(
                                                            line
                                                        )
                                                    "
                                                    (click)="
                                                        $event.stopImmediatePropagation()
                                                    "
                                                >
                                                </cmps-checkbox>
                                            </td>
                                            <td class="td2">
                                                {{
                                                    line?.startTime
                                                        | cmpsDate
                                                            : 'MMMM d, y, EEEE, h:mm:ss a'
                                                }}
                                            </td>
                                            <td class="td3">
                                                {{
                                                    line?.userName ??
                                                        line?.msftDisplayName
                                                }}
                                            </td>
                                            <td class="td4">
                                                {{ line?.message }}
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div
                        class="col h-100"
                        [class.hide]="_formHasNotes === false"
                    >
                        <div class="h-100 grid-col">
                            <ng-container [formGroup]="_form">
                                <div
                                    class="row"
                                    data-e2e="area-messages"
                                >
                                    <div
                                        class="d-inline-flex align-items-center flex-grow-1 alert-warning-compas"
                                        *ngIf="_validFocusWarning"
                                    >
                                        <cmps-icon svgIcon="alert"></cmps-icon>
                                        <div class="h6 m-0 ml-2 text-white">
                                            {{
                                                _i18n._9507_A_COMMITMENT_CANNOT_BE_CREATED_UPDATED_WITHOUT_A_FOCUS_
                                                    | translate
                                            }}
                                        </div>
                                    </div>
                                </div>
                                <div class="note-box">
                                    <div
                                        cmpsNotes
                                        class="pt-3"
                                        formControlName="observationNotes"
                                        [config]="state?.noteEntity"
                                        [hasCategoryBar]="true"
                                        [defaultCategory]="
                                            state?.defaultNoteCategory
                                        "
                                        #observation="cmpsNotes"
                                    ></div>
                                    <div
                                        *ngIf="
                                            _form?.value?.commitmentNotes
                                                ?.length > 0
                                        "
                                    >
                                        <div class="behaviour">
                                            <strong class="m-1"
                                                >{{
                                                    _i18n._9422_BEHAVIOUR_
                                                        | translate
                                                }}&nbsp;</strong
                                            >
                                            <!--TODO FIXME. see transferCommitmentToTranscript, and commitment component after rootCreateTranscriptResult when behaviours is null or empty-->
                                            {{
                                                state.cmtNotesFocus?.behaviour
                                                    ?.name ??
                                                    (_i18n._9986_NO_BEHAVIOUR_SELECTED
                                                        | translate)
                                            }}
                                            <button
                                                cmpsIconButton
                                                class="cmps-icon-button--no-bg--white edit-focus-notes"
                                                [disabled]="
                                                    !state?.allowedActions
                                                        ?.editTranscript
                                                "
                                                (click)="
                                                    _onNotesEditFocusClick()
                                                "
                                            >
                                                <cmps-icon
                                                    svgIcon="pencil"
                                                ></cmps-icon>
                                            </button>
                                        </div>
                                        <div class="sub-behaviour sb-notes">
                                            <strong
                                                >{{
                                                    _i18n._9423_SUB_BEHAVIOUR_
                                                        | translate
                                                }}&nbsp;</strong
                                            >
                                            {{
                                                state.cmtNotesFocus
                                                    ?.subBehaviour?.name ??
                                                    (_i18n._9987_NO_SUB_BEHAVIOUR_SELECTED
                                                        | translate)
                                            }}
                                        </div>
                                    </div>
                                    <div
                                        cmpsNotes
                                        formControlName="commitmentNotes"
                                        [config]="state?.noteEntity"
                                        [defaultCategory]="
                                            state?.defaultNoteCategory
                                        "
                                        [hasTagBar]="false"
                                        [hasCategoryBar]="false"
                                        [cmpsFormControlPath]="[]"
                                        [showHeader]="true"
                                        #commitment="cmpsNotes"
                                    ></div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    cmpsButton
                    class="m-2"
                    [disabled]="!_formHasNotes"
                    [class.hide]="_formHasNotes === false"
                    (click)="_onRemoveAllNotesClick()"
                >
                    <cmps-icon svgIcon="cancel"></cmps-icon>
                    <span cmpsButtonLabel>{{
                        _i18n._9990_REMOVE_ALL_NOTES | translate
                    }}</span>
                </button>
                <button
                    cmpsButton
                    [disabled]="!(state.selectedQuotes?.length > 0)"
                    (click)="_onCopyToClipboardClick()"
                >
                    <cmps-icon svgIcon="content-copy"></cmps-icon>
                    <span cmpsButtonLabel>{{
                        _i18n._9983_COPY | translate
                    }}</span>
                </button>
                <button
                    cmpsButton
                    [disabled]="!(state.selectedQuotes?.length > 0)"
                    [class.hide]="_form?.value?.commitmentNotes?.length > 0"
                    (click)="_onCreateNewNoteClick(false)"
                >
                    <cmps-icon svgIcon="plus"></cmps-icon>
                    <span cmpsButtonLabel>{{
                        _i18n._11032_ADD_OBSERVATION_NOTE | translate
                    }}</span>
                </button>
                <button
                    cmpsButton
                    [disabled]="!(state.selectedQuotes?.length > 0)"
                    [class.hide]="_form?.value?.observationNotes?.length > 0"
                    (click)="_onCreateNewNoteClick(true)"
                >
                    <cmps-icon svgIcon="plus"></cmps-icon>
                    <span cmpsButtonLabel>{{
                        _i18n._9488_ADD_COMMITMENT_NOTE | translate
                    }}</span>
                </button>
                <button
                    cmpsButton
                    class="m-2"
                    (click)="_onOpenNewObservationClick()"
                    [class.hide]="!(_form?.value?.observationNotes?.length > 0)"
                >
                    <cmps-icon svgIcon="note-plus-outline"></cmps-icon>
                    <span cmpsButtonLabel>{{
                        _i18n._9984_CREATE_NEW_OBSERVATION | translate
                    }}</span>
                </button>
                <button
                    cmpsButton
                    class="m-2"
                    (click)="_onPublishClick()"
                    [class.hide]="!(_form?.value?.commitmentNotes?.length > 0)"
                >
                    <cmps-icon svgIcon="note-plus-outline"></cmps-icon>
                    <span cmpsButtonLabel>{{
                        _i18n._9415_PUBLISH | translate
                    }}</span>
                </button>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
